import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import "./styles/main.scss";

import "bootstrap/dist/css/bootstrap.min.css";
import "@phso-dt/common/style.css";
import { ConfigProvider, useConfig } from "./contexts/ConfigContext";

const AppWithConfig = () => {
  const { config, loading, error } = useConfig();

  if (loading || error) {
    return null;
  }

  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <AppWithConfig />
    </ConfigProvider>
  </React.StrictMode>
);
